import { MessageSquare } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { formatDistanceToNow } from "date-fns";
import { cn } from "@/lib/utils";

interface ThreadPreviewProps {
  replyCount: number;
  lastReplyAt?: string;
  replierNames?: string[];
  onClick: () => void;
  className?: string;
}

export const ThreadPreview = ({
  replyCount,
  lastReplyAt,
  replierNames = [],
  onClick,
  className,
}: ThreadPreviewProps) => {
  if (replyCount === 0) return null;

  const displayNames = replierNames.slice(0, 3);
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <button
      onClick={onClick}
      className={cn(
        "flex items-center gap-2 mt-1 px-2 py-1 rounded text-xs text-primary hover:bg-primary/5 transition-colors group",
        className
      )}
    >
      <div className="flex -space-x-1">
        {displayNames.map((name, i) => (
          <Avatar key={i} className="h-5 w-5 border-2 border-background">
            <AvatarFallback className="text-[8px] bg-primary/20">
              {getInitials(name)}
            </AvatarFallback>
          </Avatar>
        ))}
      </div>
      <span className="font-medium group-hover:underline">
        {replyCount} {replyCount === 1 ? 'reply' : 'replies'}
      </span>
      {lastReplyAt && (
        <span className="text-muted-foreground">
          Last reply {formatDistanceToNow(new Date(lastReplyAt), { addSuffix: true })}
        </span>
      )}
      <MessageSquare className="h-3 w-3 text-muted-foreground" />
    </button>
  );
};
